import templateUrl from "webmodals/angularbox.htm";
//import scss from 'webmodals/angularbox.scss'

export class AngularBoxService {
  constructor() {
    var Slide, getRegister, noRel, register;
    noRel = "$$none";
    register = {};
    Slide = (function() {
      function Slide(rel, src, title) {
        this.rel = rel != null ? rel : noRel;
        this.src = src;
        this.title = title != null ? title : "";
      }
      return Slide;
    })();
    getRegister = function(rel) {
      return register[typeof rel === "undefined" ? noRel : rel];
    };
    this.add = function(rel, src, title) {
      var slide;
      if (typeof src === "undefined") {
        return void 0;
      }
      slide = new Slide(rel, src, title);
      if (register.hasOwnProperty(slide.rel)) {
        register[slide.rel].push(slide);
      } else {
        register[slide.rel] = [slide];
      }
      return (slide.id = register[slide.rel].length - 1);
    };
    this.get = function(rel, id) {
      var reg;
      if (typeof id === "undefined") {
        return null;
      }
      reg = getRegister(rel);
      if (!(0 <= id && id < reg.length)) {
        return null;
      }
      return reg[id];
    };
    this.next = function(rel, id) {
      var reg;
      reg = getRegister(rel);
      return this.get(rel, (id + 1) % reg.length);
    };
    this.prev = function(rel, id) {
      var reg;
      reg = getRegister(rel);
      if (--id < 0) {
        id = reg.length - 1;
      }
      return this.get(rel, id);
    };
  }
}

export const angularBoxService = new AngularBoxService();

export const AngularBoxDirective = () => ({
  restrict: "A",
  replace: true,
  templateUrl,
  controller($scope, $element, $timeout, $window, $document) {
    var current, hide, img, key, open, show, transition;
    current = {};
    transition = 250;
    img = angular.element($element.children()[0].childNodes[1]);
    $scope.isHidden = true;
    $scope.isLoading = false;
    $scope.isFading = false;
    key = function($event) {
      if ($scope.isHidden || $scope.isFading) {
        return;
      }
      switch ($event.keyCode) {
        case 27:
          $scope.close($event);
          break;
        case 39:
          $scope.next($event);
          break;
        case 37:
          $scope.prev($event);
      }
      $scope.$apply();
    };
    $document.bind("keydown", key);
    open = function(e, rel, id) {
      current = angularBoxService.get(rel, id);
      $scope.isHidden = false;
      $scope.$apply(show);
    };
    $scope.$on("angularboxOpen", open);
    show = function() {
      if (current) {
        $scope.src = current.src;
        $scope.caption = current.title;
      } else {
        console.warn("missing current angularbox", current);
      }
    };
    hide = function() {
      $scope.isFading = false;
      $scope.isHidden = true;
      $scope.src = $scope.caption = "";
    };
    $scope.close = function($event) {
      $event.stopPropagation();
      $scope.isFading = true;
      $timeout(hide, transition);
    };
    $scope.next = function($event) {
      $event.stopPropagation();
      current = angularBoxService.next(current.rel, current.id);
      show();
    };
    $scope.prev = function($event) {
      $event.stopPropagation();
      current = angularBoxService.prev(current.rel, current.id);
      show();
    };
    $scope["catch"] = function($event) {
      $event.stopPropagation();
    };
  }
});

export const AngularBoxSmallDirective = ($rootScope, $timeout) => ({
  restrict: "C",
  link($scope, $elm, $attrs) {
    $timeout(() => {
      var id, rel, href;
      rel = $attrs.rel || $attrs.gallery;
      href = $elm[0].href;
      id = angularBoxService.add(rel, href, $attrs.title || $attrs.dataTitle);
      $elm.bind("click", function(e) {
        e.preventDefault();
        return $rootScope.$broadcast("angularboxOpen", rel, id);
      });
    }, 1050);
  }
});

let result = {
  angularBoxService,
  AngularBoxDirective,
  AngularBoxSmallDirective
};

export default result;
